module.exports = __webpack_public_path__ + "img/CONNECT_WOORECEIVER.48f65a50.svg";